import React, { Component } from 'react';
import {Paper, Grid, Typography, Button, IconButton} from '@material-ui/core';
import * as Gserv from '../services/GatewayService';
// import Settings from '@material-ui/icons/Settings';
import DatasheetView from './DatasheetView';
import moment from 'moment';
import {VisibilityRounded,ThumbUpTwoTone} from '@material-ui/icons';

export default class InterventionsForReview extends Component {

    constructor(props) {
        super(props);
        this.state = {
            error: false,
            error_message: '',
            querying: true,
            pending_assessments_array: [],
            current_record: {},
            view_details: false,
            edit_completion_date:false,
            writing: false,
            new_completed_date: null
        }

        this.datasheetFieldSpecs = [
            { field: 'approve', headerName: 'Approve', width: 85, headerAlign: 'center', align:'center',
            sortable: false,
            renderCell: (parms) => (
                <IconButton 
                    onClick={()=>this.markApproved(parms)} 
                >
                    <ThumbUpTwoTone color='primary'/>
                </IconButton>
            )},
            { field: 'intervention', headerName: 'Intervention', width: 250},
            { field: 'employee', headerName: 'Completed By', width: 160},
            { field: 'job_title', headerName: 'Job Title', width: 160},
            { field: 'completed_date', headerName: 'Completed', width: 130},
            { field: 'assignor', headerName: 'Assigned By', width: 160},
            { field: 'created', headerName: 'Assigned', width: 120},
            { field: 'view', headerName: 'Details', width: 80, headerAlign: 'center', align:'center', sortable: false,
            renderCell: (parms) => (
                <IconButton 
                    onClick={()=>this.viewAssessment(parms)} 
                >
                    <VisibilityRounded/>
                </IconButton>
            )},

        ]
    }

    componentDidMount = () => {
        Gserv.sendCommand('query_completed_interventions',this.props.gwt)
        .then(reply=>{
            // console.log('query_completed_interventions reply :>> ', reply);
            if (reply.error){
                console.log('error on return from Gserv (query_completed_interventions) :>> ', reply);
                this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
            } else if (reply.Result!=="Success"&&reply.statusCode!==204){
                console.log('error on return from Gserv (query_completed_interventions) :>> ', reply);
                this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
            } else {
                
                //clean formats for display
                if (reply.Records){
                let record_array = reply.Records;
                    let deadline_date = null;
                    let created = null;
                    let completed = null;
                    for (var i=0;i<record_array.length;i++){
                        if (record_array[i].deadline_date){
                            deadline_date = new moment(record_array[i].deadline_date).format("YYYY-MM-DD");
                            record_array[i].deadline_date = deadline_date;
                        }
                        created = new moment(record_array[i].created).format("YYYY-MM-DD");
                        record_array[i].created = created;
                        if (record_array[i].completed_date){
                            completed = new moment(record_array[i].completed_date).format("YYYY-MM-DD");
                            record_array[i].completed_date = completed;
                        }
                        record_array[i].approved = record_array[i].approved? "YES" : null;

                    }
                }
                this.setState({querying:false, pending_assessments_array:reply.Records?reply.Records : []});

            }
        });
    };
   
    resetMe = () => {
        this.setState({error: false,error_message: '',current_record: {}, view_details: false,edit_completion_date:false, new_completed_date:null,writing:false});
    }

    viewAssessment = (record) => {
        // console.log('record :>> ', record);
        this.setState({
            current_record:record.row,
            view_details:true,
        });
    }

    markApproved = (record) => {
        this.setState({writing:true, querying:true});
        Gserv.sendCommand('update_intervention_approval',this.props.gwt,{
            intervention_id: record.id,
            toggle: 'approved'
        })
        .then(reply => {
            // console.log('createNom reply :>> ', reply);
            if (reply.error){
                console.log('error on return from Gserv (update_intervention_approval) :>> ', reply);
                this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us."});
            } else if (reply.Result!=="Success"){
                console.log('error on return from Gserv (update_intervention_approval) :>> ', reply);
                this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us."});
            } else {
                this.setState({error: false,error_message: '',current_record: {}, view_details: false,pending_assessments_array:[],querying:true,writing:false});
                this.componentDidMount();
            }
        });
    }

    render() {return (
        <Grid
            container
            direction='column'
            justifyContent='flex-start'
            alignContent='flex-start'
            // style={{backgroundColor:'yellow'}}
        >
            {!this.state.view_details&&
            <Grid item>
            <Paper
                elevation={3}
                style={{
                    // backgroundColor:'yellow',
                    width:1150
                }}
            >

                <Typography style={{padding:10}}>
                    Completed Learning Interventions (Awaiting Review)
                </Typography>

                {/* Datagrid goes here */}
                <DatasheetView 
                    dataset={this.state.pending_assessments_array}
                    fieldspecs={this.datasheetFieldSpecs}
                    delete={false}
                    edit={false}
                    handleDelete={null}
                    handleEdit={null}
                    loading={this.state.querying}
                    deleteHeaderName={'Delete'}
                    pagesize={10}
                    height={500}
                />
            </Paper>
            </Grid>}

            {this.state.view_details&&
            <Grid item>
            <Paper
                elevation={3}
                style={{
                    // backgroundColor:'yellow',
                    width:1150
                }}
            >

                <Typography style={{padding:10}}>
                    Learning Intervention Details                    
                </Typography>
                <hr/>

                <Grid
                    container
                    direction='column'
                    justifyContent='center'
                    alignItems='center'
                    style={{padding:'20px'}}
                >
                    
                    <Typography
                        style={{borderWidth:'1px',borderStyle:'solid',padding:'10px',marginBottom:'15px'}}
                    >
                        <strong>{this.state.current_record.intervention}</strong> assigned on {this.state.current_record.created} by <strong>{this.state.current_record.assignor}</strong>{this.state.current_record.deadline_date? ' required to be completed by ' : ''}<strong>{this.state.current_record.deadline_date? this.state.current_record.deadline_date : ''}</strong>
                    </Typography>      

                    {this.state.current_record.intervention_narration&&
                    <Typography style={{marginBottom:'15px'}}><i>{this.state.current_record.intervention_narration}</i></Typography>}

                    {this.state.current_record.completed_date&&!this.state.current_record.approved&&
                    <Typography>
                        Status: Completed on {this.state.current_record.completed_date}{this.state.current_record.deadline_date? (' (Deadline ' + this.state.current_record.deadline_date + ')') : ''} : <strong>awating review</strong>.
                    </Typography>}

                    {!this.state.current_record.completed_date&&
                    <Typography>
                        Status: <strong>Not yet complete</strong>.
                    </Typography>}

                    {this.state.current_record.completed_date&&this.state.current_record.approved&&
                    <Typography>
                        Status: Completed on {this.state.current_record.completed_date} : <strong>approved</strong>.
                    </Typography>}
                    
                    <Grid 
                        container
                        direction='row'
                        justifyContent='center'
                        alignItems='center'
                        style={{marginBottom:'15px', marginTop:'15px'}}
                    >
                        <Button
                            variant='contained'
                            onClick={()=>this.resetMe()}
                            style={{marginLeft:'10px'}}
                            // color='primary'
                            // type='submit'
                            disabled={this.state.writing}
                        >
                            Back
                        </Button>
                    </Grid>

                </Grid>
                

            </Paper>
            </Grid>}

            <Grid item>
                <Typography color='secondary' style={{Width:1150,maxWidth:1150, textAlign:'center'}}>{this.state.error_message}</Typography>
                {this.state.error&&<Button color='primary' variant='outlined' onClick={this.resetMe}>Reset</Button>}
            </Grid>

        </Grid>
    );}
    
}